import {MenuConsultaProdutosController} from './menuConsultaProdutosController'
import {ControllerBase} from '../../../controllerBase'
import {AmbientesView, ItemOrcamentoView, ItemOrcamentoViewOrdenacao} from '../../views/orcamento/itemOrcamentoView'
import {UltimasComprasProdutoController} from './ultimasComprasProdutoController'
//import {RegistrarPerdaCotacaoController} from './registrarPerdaCotacaoController'
import globalMU from 'globalMU'
import * as R from 'ramda'
import {forEach, forEachSeries} from "p-iteration"
import pMemoize from "p-memoize";
import React from 'react'
import { ItensOrcamentoContainer } from 'app/components/itens-orcamento/ItensOrcamentoContainer'

import {
    ativarScrollHorizontalGridItens,
    ativarScrollVerticalGridItens,
    desativarScrollHorizontalGridItens,
    desativarScrollVerticalGridItens
} from '../../../fixarGridItens'

import {AcaoAposIncluirProdutos} from '../../models/orcamento/orcamento'
import {ItensOrcamento} from 'app/models/orcamento/itemOrcamento'
import {IOrcamento} from 'app/types/IOrcamento'
import {IProduto} from 'app/types/produto/IProduto'
import produtoPodeSerAdicionadoAutomaticamenteAoOrcamento
    from 'app/use-cases/produto/produtoPodeSerAdicionadoAutomaticamenteAoOrcamento'
import microuniversoApi from 'app/api/microuniversoApi'
import store from 'app/redux/store/store'
import { atualizarItemAction } from 'app/redux/orcamentoSlice'
import { removerComponenteReact, renderizarComponentReact } from 'app/components/renderizarOuRemoverComponentReact'
import { MenuConsultaProdutos } from 'app/components/menu-consulta-produtos/MenuConsultaProdutos'

const Backbone = require('backbone')
const _ = require('underscore')

var paramUltimaVenda

declare var window
declare var parametroSistema


/**
 * variáveis globais definidas em itemOrcamentoView
 * não foi possível colocá-las no sistema de módulos por enquanto
 *
 */
declare var $elementoComFocoEdicaoQuantidadeItemGrid
declare var $elementoComFocoEdicaoPedidoCompraItemGrid
declare var $IndexEdicaoPedidoCompraItemGrid
declare var $IndexEdicaoQuantidadeItemGrid
declare var $elementoComFocoEdicaoPrecoUnitItemGrid
declare var $IndexEdicaoPrecoUniItemGrid
declare var $elementoComFocoEdicaoCentroCustoItemGrid
declare var $IndexEdicaoCentroCustoItemGrid
declare var $elementoComFocoEdicaoMarkUpItemGrid
declare var $IndexEdicaoMarkUpItemGrid
declare var $elementoComFocoEdicaoLinhaOrdemCompraItemGrid
declare var $IndexEdicaoLinhaOrdemCompraItemGrid



const ItemOrcamentoController = ControllerBase.extend({
    name: "ItemOrcamentoController",

    initialize: function () {


        this.menuConsultaProdutosController = new MenuConsultaProdutosController({
            controller: this,
            orcamento: this.model,
            obterModelCallback: $.proxy(this.obterItemSelecionado, this),
            adicionarProdutosCallback: $.proxy(this.adicionarProdutos, this)
        })

        paramUltimaVenda = parametroSistema.obter('CONSULTA_ULTIMA_VENDA_ORCAMENTO');
        this.param_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = parametroSistema.obter('ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL');



    },



});

window.ItemOrcamentoController = ItemOrcamentoController

export {
    ItemOrcamentoController
}
